import React from "react";
import hoistNonReactStatic from "hoist-non-react-statics";
import Context from "./Context";
import { getLogEntryActionPayload } from "./utils";

const makeTrackableProps = (mapActionToId, props, logger) => {
  let resultMapActionToId = mapActionToId;
  let keys;

  if (typeof mapActionToId === "function") {
    const mapActionWithIds = mapActionToId(props);
    resultMapActionToId = mapActionWithIds;
    keys = Object.keys(mapActionWithIds);
  } else {
    keys = Object.keys(mapActionToId);
  }

  return keys.reduce((ac, key) => {
    ac[key] = (...args) => {
      if (props.hasOwnProperty(key)) {
        logger.logEvent(getLogEntryActionPayload(resultMapActionToId[key], args));
        return props[key](...args);
      } // if this new props then just call log event


      logger.logEvent(getLogEntryActionPayload(resultMapActionToId[key], args));
    };

    return ac;
  }, {});
};

export const withTrackProps = mapActionToId => WrappedComponent => {
  class WithPropsTracker extends React.PureComponent {
    render() {
      const props = { ...this.props,
        ...makeTrackableProps(mapActionToId, this.props, this.context)
      };
      return /*#__PURE__*/React.createElement(WrappedComponent, props);
    }

  }

  WithPropsTracker.contextType = Context;
  hoistNonReactStatic(WithPropsTracker, WrappedComponent);
  return WithPropsTracker;
};